var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 212,
    viewBox: "0 0 356 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_29613)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 211.2,
    rx: 25.6,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.5,
    y1: -2.18557e-8,
    x2: 232.5,
    y2: 211.2,
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.969,
    y1: 69.9999,
    x2: 356,
    y2: 69.9999,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.969,
    y1: 140.4,
    x2: 356,
    y2: 140.4,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.379 12C293.469 11.999 292.575 12.2368 291.786 12.6894L276.992 21.2082C275.388 22.1317 274.4 23.8382 274.4 25.6852V42.7227C274.4 44.5696 275.388 46.2762 276.992 47.1996L291.786 55.7184C293.39 56.6421 295.367 56.6421 296.971 55.7184L311.765 47.1996C313.369 46.2762 314.358 44.5696 314.358 42.7227V25.6852C314.358 23.8382 313.369 22.1317 311.765 21.2082L296.971 12.6894C296.183 12.2368 295.289 11.999 294.379 12Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.535 36.9596C299.535 34.0721 297.803 33.0821 294.338 32.6697C291.863 32.3397 291.368 31.6797 291.368 30.5246C291.368 29.3695 292.193 28.6272 293.843 28.6272C295.328 28.6272 296.153 29.1222 296.565 30.3597C296.648 30.6072 296.895 30.7721 297.143 30.7721H298.463C298.793 30.7721 299.04 30.5246 299.04 30.1947V30.1122C298.71 28.2971 297.225 26.8947 295.328 26.7297V24.7497C295.328 24.4197 295.08 24.1722 294.668 24.0896H293.43C293.1 24.0896 292.853 24.3371 292.77 24.7497V26.6472C290.295 26.9772 288.728 28.6272 288.728 30.6897C288.728 33.4122 290.378 34.4846 293.843 34.8972C296.153 35.3096 296.895 35.8046 296.895 37.1247C296.895 38.4448 295.74 39.3522 294.173 39.3522C292.028 39.3522 291.285 38.4446 291.038 37.2071C290.955 36.8772 290.708 36.7121 290.46 36.7121H289.058C288.728 36.7121 288.48 36.9596 288.48 37.2896V37.3722C288.81 39.4346 290.13 40.9196 292.853 41.3322V43.3122C292.853 43.6421 293.1 43.8896 293.513 43.9721H294.75C295.08 43.9721 295.328 43.7246 295.41 43.3122V41.3322C297.885 40.9196 299.535 39.1871 299.535 36.9596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.54 29.7822C280.148 36.1348 283.448 43.3123 289.883 45.6221C290.13 45.7873 290.378 46.1171 290.378 46.3646V47.5198C290.378 47.6847 290.378 47.7673 290.295 47.8496C290.213 48.1797 289.883 48.3446 289.553 48.1797C284.933 46.6947 281.385 43.1471 279.9 38.5272C277.425 30.6898 281.715 22.3572 289.553 19.8822C289.635 19.7998 289.8 19.7998 289.883 19.7998C290.213 19.8822 290.378 20.1297 290.378 20.4597V21.6147C290.378 22.0273 290.213 22.2748 289.883 22.4397C286.5 23.6772 283.778 26.3172 282.54 29.7822ZM297.885 20.2123C297.968 19.8822 298.298 19.7173 298.628 19.8822C303.165 21.3672 306.795 24.9148 308.28 29.6173C310.755 37.4547 306.465 45.7873 298.628 48.2623C298.545 48.3447 298.38 48.3447 298.298 48.3447C297.968 48.2623 297.803 48.0148 297.803 47.6847V46.5298C297.803 46.1172 297.968 45.8697 298.298 45.7048C301.68 44.4673 304.403 41.8273 305.64 38.3623C308.033 32.0097 304.733 24.8322 298.298 22.5224C298.05 22.3572 297.803 22.0274 297.803 21.6973V20.5424C297.803 20.3772 297.803 20.2949 297.885 20.2123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.185 32.5H232.5V42.4407H221.185C213.235 42.4407 205.77 45.9948 201.198 51.9847L166.755 97.1108C165.942 98.1761 165.065 99.1886 164.131 100.145L163.302 100.995H164.489H232.5V110.935H164.42H163.228L164.063 111.786C165.023 112.763 165.923 113.798 166.755 114.889L201.198 160.015C205.77 166.005 213.235 169.559 221.185 169.559H232.5V179.5H221.185C209.622 179.5 198.804 174.33 192.198 165.676L157.756 120.549C153.184 114.56 145.719 111.005 137.769 111.005H115.5V100.995L137.819 100.995H137.82C145.751 100.979 153.194 97.4276 157.756 91.4506L192.198 46.3245C198.804 37.6701 209.622 32.5 221.185 32.5Z",
    fill: "url(#paint0_linear_1748_29613)",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.119 154.206C293.209 154.205 292.315 154.442 291.527 154.895L276.733 163.414C275.129 164.337 274.14 166.044 274.14 167.891V184.928C274.14 186.775 275.129 188.482 276.733 189.405L291.527 197.924C293.131 198.848 295.107 198.848 296.712 197.924L311.506 189.405C313.109 188.482 314.098 186.775 314.098 184.928V167.891C314.098 166.044 313.109 164.337 311.506 163.414L296.712 154.895C295.923 154.442 295.029 154.205 294.119 154.206Z",
    fill: "#56ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.583 174.541L299.582 174.542C300.615 175.858 301.232 177.526 301.232 179.34C301.232 181.181 300.596 182.871 299.536 184.197L299.445 184.311L299.421 184.166C299.4 184.043 299.376 183.918 299.348 183.792C298.817 181.421 297.088 179.388 294.243 177.741C292.321 176.632 291.221 175.297 290.932 173.78C290.746 172.8 290.885 171.814 291.152 170.97C291.42 170.127 291.819 169.42 292.157 168.994L293.264 167.617C293.459 167.376 293.822 167.376 294.016 167.617L299.583 174.541ZM301.334 173.165L293.914 163.938C293.773 163.761 293.508 163.761 293.366 163.938L285.947 173.165L285.923 173.196C284.557 174.919 283.74 177.109 283.74 179.493C283.74 185.044 288.173 189.545 293.64 189.545C299.108 189.545 303.54 185.044 303.54 179.493C303.54 177.109 302.723 174.919 301.358 173.196L301.334 173.165ZM287.722 174.511L288.386 173.685L288.406 173.837C288.422 173.958 288.441 174.08 288.464 174.201C288.893 176.493 290.427 178.403 292.992 179.883C295.221 181.174 296.519 182.657 296.893 184.285C297.049 184.964 297.076 185.632 297.009 186.216L297.005 186.253L296.973 186.269C295.966 186.769 294.835 187.049 293.64 187.049C289.447 187.049 286.048 183.598 286.048 179.34C286.048 177.512 286.675 175.832 287.722 174.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.379 83.2C293.469 83.1989 292.575 83.4367 291.786 83.8894L276.992 92.4081C275.388 93.3316 274.4 95.0381 274.4 96.8851V113.923C274.4 115.77 275.388 117.476 276.992 118.4L291.786 126.918C293.39 127.842 295.367 127.842 296.971 126.918L311.765 118.4C313.369 117.476 314.358 115.77 314.358 113.923V96.8851C314.358 95.0381 313.369 93.3316 311.765 92.4081L296.971 83.8894C296.183 83.4367 295.289 83.1989 294.379 83.2Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.428 107.4C296.288 107.411 295.564 107.454 293.951 107.454C292.667 107.454 291.756 107.416 291.436 107.4C286.476 107.182 282.774 106.319 282.774 105.285C282.774 104.251 286.476 103.389 291.436 103.167V106.541C291.76 106.564 292.689 106.619 293.973 106.619C295.513 106.619 296.284 106.555 296.423 106.542V103.17C301.373 103.39 305.067 104.254 305.067 105.285C305.067 106.317 301.374 107.18 296.423 107.399L296.428 107.4ZM296.428 102.821V99.8026H303.336V95.2H284.529V99.8026H291.435V102.82C285.821 103.077 281.6 104.189 281.6 105.522C281.6 106.854 285.821 107.965 291.435 108.224V117.896H296.427V108.22C302.028 107.962 306.242 106.852 306.242 105.521C306.242 104.189 302.031 103.079 296.427 102.82L296.428 102.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 35.4,
    width: 149.035,
    height: 141.944,
    rx: 15.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 35.4,
    width: 149.035,
    height: 141.944,
    rx: 15.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1748_29613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.917 59C106.963 58.9979 105.042 59.5051 103.349 60.4708L71.5689 78.6441C68.1235 80.6142 66 84.2548 66 88.195V124.542C66 128.482 68.1235 132.122 71.5689 134.093L103.349 152.266C106.795 154.236 111.04 154.236 114.486 152.266L146.266 134.093C149.711 132.122 151.835 128.482 151.835 124.542V88.195C151.835 84.2548 149.711 80.6142 146.266 78.6441L114.486 60.4708C112.793 59.5051 110.872 58.9979 108.917 59Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.917 59C106.963 58.9979 105.042 59.5051 103.349 60.4708L71.5689 78.6441C68.1235 80.6142 66 84.2548 66 88.195V124.542C66 128.482 68.1235 132.122 71.5689 134.093L103.349 152.266C106.795 154.236 111.04 154.236 114.486 152.266L146.266 134.093C149.711 132.122 151.835 128.482 151.835 124.542V88.195C151.835 84.2548 149.711 80.6142 146.266 78.6441L114.486 60.4708C112.793 59.5051 110.872 58.9979 108.917 59Z",
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.602 82.1006C129.315 85.9839 134.047 92.5213 135.677 99.9246L135.671 99.9027C136.675 104.299 133.201 108.583 128.691 108.704L128.554 108.707L128.535 108.707L113.879 108.73L121.202 121.483L121.247 121.56C123.558 125.592 121.498 130.653 117.098 132.088L116.963 132.13L116.915 132.145L116.866 132.158C109.393 134.164 101.589 133.313 94.9966 129.499C88.2833 125.616 83.5517 119.078 81.9222 111.675L81.9273 111.697C80.9238 107.3 84.3974 103.017 88.9078 102.895L89.0448 102.893L89.0639 102.893L103.719 102.87L96.3972 90.1171L96.3517 90.0394C94.0411 86.0074 96.101 80.9465 100.501 79.512L100.636 79.4692L100.684 79.4545L100.733 79.4415C108.206 77.4352 116.009 78.287 122.602 82.1006ZM106.336 108.71L106.302 108.71L106.28 108.711L106.258 108.711L89.0867 108.737L89.0478 108.738C88.1781 108.774 87.4708 109.632 87.6065 110.358L87.6141 110.394L87.619 110.416C88.898 116.227 92.6273 121.379 97.9135 124.437C103.124 127.451 109.335 128.129 115.356 126.513L115.298 126.528L115.306 126.525C116.223 126.217 116.619 125.245 116.194 124.481L116.172 124.443L116.158 124.42L116.145 124.397L107.576 109.473L107.565 109.454L107.554 109.434C107.296 108.968 106.864 108.712 106.336 108.71ZM102.243 85.0871L102.301 85.072L102.293 85.0742C101.376 85.3822 100.979 86.3543 101.405 87.1189L101.427 87.1569L101.441 87.1796L101.454 87.2024L110.023 102.127L110.034 102.146L110.045 102.165C110.303 102.631 110.735 102.888 111.263 102.89L111.296 102.889L111.319 102.889L111.341 102.889L128.512 102.862L128.551 102.861C129.421 102.826 130.128 101.967 129.992 101.242L129.985 101.205L129.98 101.183C128.701 95.3728 124.971 90.2201 119.685 87.1624C114.475 84.1486 108.264 83.4706 102.243 85.0871Z",
    fill: "url(#paint1_radial_1748_29613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.233 102.887H92.3672V108.712H125.233V102.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67677 106.626C8.05969 106.002 8.05969 104.998 8.67677 104.374L18.8628 94.0829C19.8683 93.0669 21.6 93.779 21.6 95.2084L21.6 115.792C21.6 117.221 19.8683 117.933 18.8628 116.917L8.67677 106.626Z",
    fill: "#FDFDFD",
    fillOpacity: 0.4,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.374 11.6768C108.998 11.0597 110.002 11.0597 110.626 11.6768L120.917 21.8628C121.933 22.8683 121.221 24.6 119.792 24.6L99.2084 24.6C97.779 24.6 97.0669 22.8683 98.0829 21.8628L108.374 11.6768Z",
    fill: "#FDFDFD",
    fillOpacity: 0.4,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.374 201.067C108.998 201.684 110.002 201.684 110.626 201.067L120.917 190.881C121.933 189.875 121.221 188.144 119.792 188.144H99.2084C97.779 188.144 97.0669 189.875 98.0829 190.881L108.374 201.067Z",
    fill: "#FDFDFD",
    fillOpacity: 0.4,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 355.2,
    height: 210.4,
    rx: 25.2,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1748_29613",
    x: 22.8,
    y: 15.8,
    width: 172.235,
    height: 181.144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.479253 0 0 0 0 0.942878 0 0 0 0.197033 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1748_29613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1748_29613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1748_29613",
    x1: 217,
    y1: 34,
    x2: 217,
    y2: 179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1748_29613",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.799 105.8) rotate(-180) scale(15.0711 14.8708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_29613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 211.2,
    rx: 25.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bde123adc9858103147b04495c4de5ca.svg";
export { ForwardRef as ReactComponent };